module.exports = __webpack_public_path__ + "img/keyvisual.9045687f.jpg";